export default {
  name: 'donate',
  props: {
    siteName: String
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'NH Roads',
          disabled: false,
          href: '/'
        },
        {
          text: 'Donate',
          disabled: false,
          href: '/donate'
        },
      ]
    }
  },
  async created() {
  },
  async mounted () {
  },
  methods: {}  
}